export const AMPLITUDE_EVENT_NAMES = {
    DRAWDOWN_AMOUNT_SELECTED: 'Drawdown amount selected',
    DASHBOARD_BENEFITS_HOVERED: 'Dashboard benefits hovered',
    AMOUNT_SLIDER_USED: 'Amount slider used',
    REPAYMENT_SCHEDULE_VIEWED: 'Repayment schedule viewed',
    EARLY_REPAYMENT_CALCULATOR_USED: 'Early repayment calculator used',
    OPENED_REQUIREMENT_MODAL: 'Funding requirement modal opened',
    FUNDING_REQUIREMENT_COMPLETED: 'Funding requirement completed',
    CLOSED_REQUIREMENT_MODAL: 'Funding requirement modal closed',
    COMPLETED_LEGAL_DOCUMENT: 'Legal document signed',
    OFFER_SELECTED: 'Offer selected',
    LOAN_BUILDER_ERROR: 'Loan builder error',
    APPLICATION_ON_HOLD_VIEWED: 'Application on hold viewed',
    APPLICATION_ON_HOLD_CTA_CLICKED: 'Application on hold CTA clicked',
    ERROR_MODAL_OPENED: 'Fallback error modal opened',
    DOCS_REQUIRED_ALERT_BOX_CLICKED: 'Docs required alert box clicked',
    DOCS_SUBMITTED_VIA_FLEXI_INLINE_TOPUP_FORM:
        'Docs submitted via flexi inline topup form'
};
